/** Shows the Agency pass-through MBS preset view tab; off hides it and a link to it opens the default view. */
export const ENABLE_SECURITIZED_VIEW =
  'ff.frontend_platform.marketplace_securitized_view'
